import Smart from 'hocs/smart';
import View from './course-view';

export default Smart(
  View,
  state => ({
    units: state.settings.units.bearing
  }),
  () => ({
  })
);
